import { useState, useEffect } from 'react';
import { tagsMapFor } from '../../../data/tagAssignments';
import API from '../../../data/api';

/**
 * Loads the User tags and a userId → tags map so the "Etiquetas" column can be filtered.
 */
export function useUserTags(rows) {
    const [availableTags, setAvailableTags] = useState([]);
    const [userTagsMap, setUserTagsMap] = useState({});

    useEffect(() => {
        const fetchTags = async () => {
            try {
                const api = API.Instance();
                const response = await api.requestTags({ modelType: 'User' });
                const tags = response.tags || [];
                setAvailableTags(tags);

                // One request for every row's tags (data/tagAssignments.js)
                const tagsMap = await tagsMapFor(rows, 'User', tags);
                setUserTagsMap(tagsMap);
            } catch (error) {
                console.error('Error fetching tags:', error);
            }
        };
        if (rows && rows.length > 0) {
            fetchTags();
        }
    }, [rows]);

    const hasTag = (userId, tagId) => (userTagsMap[userId] || []).some((tag) => tag._id === tagId);

    return { availableTags, userTagsMap, hasTag };
}
